/**
 * Root React router: four surfaces — (1) auth (login/register/forgot), (2) config (masters,
 * opening balances, settings), (3) operational (daily sales, day close, reports), (4) admin/owner
 * (super-admin dashboard, owner analytics). Post-login landing uses LAST_SCREEN from the API
 * (stored in localStorage by Login) to reopen the user's last route instead of a fixed home.
 */
import './App.css';
import 'rc-time-picker/assets/index.css';
import { Route, Switch} from 'react-router-dom';
import { React, useEffect, useMemo, useState } from "react";
import Registration from './components/Registration.component';
import PumpDetails from './components/pump/PumpDetails.component';
import Subscription from './components/Subscription.component';
import Login from './components/Login.component.jsx';
import FuelConfig from './components/fuel/FuelConfig.component';
import CreditDebit from './components/transaction/CreditDebit.component';
import PrivateRoute from './PrivateRoute';
import TankConfig from './components/fuel/TankConfig.component'
import Logout from './components/logout';
import Forgotpassworduser from './components/Forgotpassworduser.component';
import ForgotUserName from './components/ForgotUserName.component';
import SuccessUsername from './components/SuccessUsername.component';
import Successpassword from './components/Successpassword.component';
import Setnewpassworduser from './components/Setnewpassworduser.component';
import TargetConfig from './components/pump/TargetConfig.component';
import RackConfig1 from './components/rack/RackConfig1.component'
import Product from './components/product/Product.component'
import UsersList from './components/users/UsersList.component'
import Settings from './components/settings/Settings.Component'
import fuelConfigReport from './components/report/fuelConfigReport.component';
import NonfuelConfigReport from './components/report/NonfuelConfigReport.component'
import NozzleConfig from './components/Nozzleconfig.component'
import ProductRack from './components/rack/ProductRack.component'
import RackProductList from './components/rack/RackProductList.component'
import DigitalPayment from './components/transaction/DigitalPayment.component'
import Customer from './components/customers/Customer.component'
import BankOpeningBalance from './components/bank/BankOpeningBalance.component'
import FleetCardConfig from './components/fleetcard/FleetCardConfig.component'
import MlaCoupon from './components/mlacoupon/MlaCoupon.component'
import EmployeeOpeningBalance from './components/employee/EmployeeOpeningBalance.component'
import VendorConfig from './components/vendor/VendorConfig.component'
import DealershipConfig from './components/dealership/DealershipConfig.component'
import OpenBalance from './components/transaction/OpenBalance.component'
import OwnTankerConfig from './components/tanker/OwnTankerConfig.component'
import TankerConfig from './components/tanker/TankerConfig.component'
import TankerExpConfig from './components/tanker/TankerExpConfig.component'
import MachineriesConfig from './components/assets/MachineriesConfig.component'
import OtherIncome from './components/transaction/OtherIncome.component'
import ExpensesConfig from './components/transaction/ExpensesConfig.component'
import TaskConfig from './components/transaction/TaskReminders.component';
import FuelUnloading from './components/fuel/FuelUnloading.component';
import FuelConfig2 from './components/fuel/FuelConfig2.component';
import BalanceSheet from './components/balance-sheet/BalanceSheet.component'
import BalanceSheet1 from './components/balance-sheet/balancesheet1.component'
import NozzleAlloEmplist from './components/operational-model/Employee/nozzle/NozzleAlloEmplist.component'
import NozzleAllocation from './components/operational-model/Employee/nozzle/NozzleAllocation.component'
import NozzleAllocation2 from './components/operational-model/Employee/nozzle/NozzleAllocation2.component.jsx'
import NozzleAlloEmplist2 from './components/operational-model/Employee/nozzle/NozzleAlloEmplist2.component.jsx'
import PackedOilConfig from './components/operational-model/Employee/PackedOil/PackedOilConfig.component'
import LooseOilConfig from './components/operational-model/Employee/LooseOil/LooseOilConfig.component'
import CreditSalesConfig from './components/operational-model/Employee/CreditSales/CreditSalesConfig.component'
import MlaCouponConfig from './components/operational-model/Employee/MlaCoupon/MlaCouponConfig.component'
import FleetCardSalesConfig from './components/operational-model/Employee/FleetCardSales/FleetCardSalesConfig.component'
import CardSalesConfig from './components/operational-model/Employee/DigitalPayement/CardSalesConfig.component'
import BagCollectionConfig from './components/operational-model/Employee/BagCollection/BagCollectionConfig.component'
import ExpenseConfig from './components/operational-model/Employee/Expense/ExpenseConfig.component';
import ReceiptVoucherConfig from './components/operational-model/Employee/ReceiptVoucher/ReceiptVoucherConfig.component';
import  CashPaymentConfig from './components/operational-model/Employee/CashPayment/CashPaymentConfig.component';
import  ClosePaymentConfig from './components/operational-model/Employee/ClosePayment/ClosePaymentConfig.component';
import OperationalDate from './components/operational-model/OperationalDate.component';
import OperationalDates from './components/operational-model/OperationalDates.component';
import ReceiptConfig from './components/operational-model/Manager/Receipt/ReceiptConfig.component';
import PaymentVoucherConfig from './components/operational-model/Manager/PaymentVoucher/PaymentVoucherConfig.component';
import NonFuelProductConfig from './components/operational-model/Manager/NonFuelProduct/NonFuelProductConfig.component';
import Productsconfig from './components/product/Productsconfig.component.jsx';
import { GasCylinderSalesConfig } from './components/product/GasCylinderSalesConfig.jsx';
import { GasCylinderSalesEmployeeConfig } from './components/product/GasCylinderSalesEmployeeConfig.jsx'; 
import GasCylinderPurchaseConfig from './components/product/GasCylinderPurchaseConfig.jsx';
import NonFuelProductConfigEmployee from './components/operational-model/Manager/NonFuelProductemployee/NonFuelProductConfigEmployee.component.jsx';
import  NonFuelProductPurchaseConfig  from './components/operational-model/Manager/NonFuelProductPurchase/NonFuelProductPurchaseConfig.component';
import FuelSellPriceConfig from './components/operational-model/Manager/FuelSellPriceChange/FuelSellPriceChangeConfig.component';
import ProductTransferRackConfig from './components/operational-model/Manager/ProductTransferRack/ProductTransferRackConfig.component';
import  AccountToAccountConfig from './components/operational-model/Manager/AccountToAccountTransfer/AccountToAccountTransferConfig.component';
import  DayClosingOperationConfig from './components/operational-model/Manager/DayClosingOperation/DayClosingOperationConfig.component';
import  DayClosingScreenConfig from './components/operational-model/Manager/DayClosingScreen/DayClosingScreenConfig.component';
import  PurchaseReturnNonFuelConfig  from './components/operational-model/Manager/PurchaseReturnNonFuel/PurchaseReturnNonFuelConfig.component';
import  UserManagementConfig  from './components/operational-model/Manager/UserManagement/UserManagementConfig.component';
import  NotificationSettingConfig  from './components/operational-model/Manager/NotificationSetting/NotificationSettingConfig.component';
import  SubscriptionManagementConfig  from './components/operational-model/Manager/SubscriptionManagement/SubscriptionManagementConfig.component';
import  InvoiceSettingsConfig  from './components/operational-model/Manager/InvoiceSettings/InvoiceSettingsConfig.component';
import  NonFuelProductSellingPriceChangeConfig  from './components/operational-model/Manager/NonFuelProductSellingPriceChange/NonFuelProductSellingPriceChangeConfig.component';
import   OperationalSettings  from './components/operational-model/operational-settings/OperationalSettings.component';
import LoginHeaderOperational from './components/operational-model/LoginHeaderOperational';
import AllNotification from './components/Notification/AllNotification.component';
import ReportDownloads from './components/Notification/ReportDownloads.component';
import DsrConfig from './components/operational-model/Employee/DsrReport/DSRReportView.component';
import Roles from './components/permissions/RoleConfig.component';

import RecoupConfig from './components/operational-model/Employee/Recoup/RecoupConfig.component';
import FuelUnloadingConfig1 from './components/operational-model/Manager/Fuel-Unloading/FuelUnloadingConfig1.component'
import FuelUnloadingConfig from './components/operational-model/Manager/FuelPurchase/FuelUnloadingConfig1.component'
import FuelUnloadingConfig2 from './components/operational-model/Manager/Fuel-Unloading/FuelUnloadingConfig2.component'
import FuelUnloadingDensityConfig from './components/operational-model/Manager/Fuel-Unloading/FuelUnloadingDensityConfig.component'
import FuelUnConfig from './components/operational-model/Manager/Fuel-Un/FuelUnConfig.component'
import DensityAfterUnloadConfig from './components/operational-model/Manager/Fuel-Unloading/DensityAfterUnloadingConfig.component';
import DecantingMSConfig from './components/operational-model/Manager/Fuel-Unloading/DecantingMSConfig.component';
import DayClosingConfig from './components/operational-model/DayClosing/DayClosingConfig.component';
import BalanceSheetOP from  './components/operational-model/BalanceSheetOP.component';
import ProfitLossOP from  './components/operational-model/ProfitLossOP.component';
import SimplifiedBalanceSheet from  './components/operational-model/SimplifiedBalanceSheet.component'
import FinancialStatements from './components/operational-model/FinancialStatements.component'
import StatutoryFilingReports from './components/operational-model/StatutoryFilingReports.component'
import DailyTransactionSheet from  './components/operational-model/DailyTransactionSheet.component'
import TradeProfitLossReport from './components/operational-model/TradeProfitLossReport.component';
import ShortExcessReport from './components/operational-model/ShortExcessReport.component';
import OtherIncomeReport from './components/operational-model/OtherIncomeReport.component';
import CustomerStatementReport from './components/operational-model/CustomerStatementReport.component';
import BankStatementReport from './components/operational-model/BankStatementReport.component';
import DealerStatementReport from './components/operational-model/DealerStatementReport.component';
import FleetCardStatementReport from './components/operational-model/FleetCardStatementReport.component';
import MlaCouponStatementReport from './components/operational-model/MlaCouponStatementReport.component';
import NonFuelPurchaseReport from './components/operational-model/NonFuelPurchaseReport.component';
import NonFuelSalesReport from './components/operational-model/NonFuelSalesReport.component';
import NonFuelStockStatementReport from './components/operational-model/NonFuelStockStatementReport.component';
import RecoupStatementReport from './components/operational-model/RecoupStatementReport.component';
import NozzleReport from './components/operational-model/NozzleReport.component';
import LooseOilBarrelSalesReport from './components/operational-model/LooseOilBarrelSalesReport.component';
import EmployeeWorkSheet from './components/operational-model/Employee/EmployeeWorksheetComponent';
import DsrReportComponent from './components/operational-model/Employee/DsrReport/DsrReport.component';

import DensityConfig from './components/operational-model/Employee/DensityReport/DensityReportView.component';
import Density from './components/operational-model/Employee/DensityReport/DensityConfig.component';
import DailyTransactionSummary from './components/operational-model/DailyTransactionSummary.component'
import AccountStatementReport from './components/operational-model/AccountStatementReport.component';
import StockGainLossReport from './components/operational-model/StockGainLossReport.component';
import OtherReportRouter from './components/operational-model/OtherReportRouter.component';
import DashBoard from './components/operational-model/Employee/DashBoard.component';
import OwnerDashboard from './components/operational-model/Owner/OwnerDashboard.component';
import OwnerAnalyticsReport from './components/operational-model/Owner/OwnerAnalyticsReport.component';
import FuelEdit from './components/operational-model/OPFuelEdit/FuelEditComponent'
import TankEdit from './components/operational-model/OPFuelEdit/TankEdit.component'
import NozzleEdit from './components/operational-model/OPFuelEdit/NozzleEdit.component'
import paymentFailed from './components/Payment/PaymentFail'
import PaymentSuccess from './components/Payment/PaymentSuccess.component.jsx'
import AdminDashBoard from './components/operational-model/Admin/AdminDashBoard.component';
import AdminLedgerErrors from './components/operational-model/Admin/AdminLedgerErrors.component.jsx';
import AdminTankStockErrors from './components/operational-model/Admin/AdminTankStockErrors.component.jsx';
import SetPump from './components/operational-model/Admin/Pump/SetPump.component';
import Permision from './components/permissions/PermissionConfig.component';
import AdminRoles from './components/operational-model/Admin/Role/RoleConfig.component';
import AdminSubscriptionManagement from './components/operational-model/Admin/Subscription/AdminSubscriptionManagement.component';
import AdminPaymentManagement from './components/operational-model/Admin/Payments/AdminPaymentManagement.component';
import AdminInvoiceSettings from './components/operational-model/Admin/InvoiceSettings/AdminInvoiceSettings.component';
import AdminUserManagementConfig from './components/operational-model/Admin/UserManagement/UserManagementConfig.component';
import PageNotFound from './components/PageNotFound.component';
import TankModalView from './components/operational-model/OPFuelEdit/TankModalViewComponent'
import getDetails from "./components/getDetails";
import { useHistory, useLocation } from "react-router-dom";
import { API_URL } from "./constant/API_Settings";
import { isPlatformSuperAdmin } from "./utils/platformAuth";
import LooseOilComponent from './components/looseoil/LooseOilComponent';
import Loosebarrelmachine from './components/looseoil/Loosebarrelmachine.jsx';
import OilBarrelProductConfigEmployee from './components/operational-model/Manager/OilBarrelProduct/OilBarrelProductConfigEmployee.jsx';
import OilBarrelProductConfig from './components/operational-model/Manager/OilBarrelProduct/OilBarrelProductConfig.jsx';
import AdminPumpsDetailscomponent from './components/operational-model/Admin/UserManagement/AdminPumpsDetails.component.jsx';
import AdminPumpDetail from './components/operational-model/Admin/AdminPumpDetail.component.jsx';
import AdminAlertsCenter from './components/operational-model/Admin/AdminAlertsCenter.component.jsx';
import AdminSupportCenter from './components/operational-model/Admin/AdminSupportCenter.component.jsx';
import AdminAuditLog from './components/operational-model/Admin/AdminAuditLog.component.jsx';
import AdminPlatformAnalytics from './components/operational-model/Admin/AdminPlatformAnalytics.component.jsx';
import AdminBusinessInsights from './components/operational-model/Admin/AdminBusinessInsights.component.jsx';
import AdminMasterSettings from './components/operational-model/Admin/AdminMasterSettings.component.jsx';
import AdminSystemMonitoring from './components/operational-model/Admin/SystemMonitoring/AdminSystemMonitoring.component.jsx';
import ImpersonationBanner from './components/layouts/ImpersonationBanner.component.jsx';
/*Maintenance Mode*/
import Maintenance from "./Maintenance";
import ForceLogoutPoller from "./components/auth/ForceLogoutPoller.component";
import { logoutSignedInElsewhere } from "./utils/sessionLogout";
import { AppPropsContext, createAppRoute } from "./context/AppPropsContext";
export default function App() {
  const history = useHistory();
  const location = useLocation();
  const [maintenanceMode, setMaintenanceMode] = useState(false);
  const [maintenanceMessage, setMaintenanceMessage] = useState('');
  const [maintenanceChecked, setMaintenanceChecked] = useState(false);
  const [isSuperAdminSession, setIsSuperAdminSession] = useState(false);
  const permission_details = useMemo(() => {
    return getDetails();
  }, []);
const [baseProps, setBaseProps] = useState({
    permission_details: {
      ...permission_details,
    },
  });
  const props = useMemo(() => {
    return {
      ...baseProps,   
      setBaseProps: setBaseProps,
    };
  }, [baseProps]);

  useEffect(() => {
    const token = localStorage.getItem("AUTH_TOKEN");
    checkMaintenanceStatus(token);
    if (token) {
      check_meta_date();
      fetchPlatformSuperAdminFlag(token);
    } else {
      setIsSuperAdminSession(false);
    }
  }, []);

  function fetchPlatformSuperAdminFlag(token) {
    fetch(`${API_URL}/check_meta_date`, {
      method: 'post',
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + token,
        "Accept": "application/json",
      },
      body: JSON.stringify({ pathurl: window.location.pathname }),
    })
      .then((response) => response.json())
      .then((profile) => {
        setIsSuperAdminSession(isPlatformSuperAdmin(profile));
      })
      .catch(() => setIsSuperAdminSession(false));
  }

  function checkMaintenanceStatus(token) {
    const headers = {
      Accept: "application/json",
    };
    if (token) {
      headers.Authorization = "Bearer " + token;
    }
    fetch(`${API_URL}/maintenance-status`, { method: "GET", headers })
      .then((response) => response.json())
      .then((data) => {
        if (data && data.maintenance) {
          setMaintenanceMode(true);
          setMaintenanceMessage(data.message || '');
        } else {
          setMaintenanceMode(false);
          setMaintenanceMessage('');
        }
      })
      .catch(() => {})
      .finally(() => setMaintenanceChecked(true));
  }

  function handleSessionMaintenance(message) {
    setMaintenanceMode(true);
    setMaintenanceMessage(message || '');
    localStorage.removeItem("AUTH_TOKEN");
    setIsSuperAdminSession(false);
  }

  function check_meta_date() {

    const requestOptions = {
      method: 'post',
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
        "Accept": "application/json"

      }
    };
    fetch(`${API_URL}/check_meta_date`, requestOptions)
      .then(response => { return response.json(); })
      .then(responseData => {
        
        if (responseData.message == "Unauthenticated.") {
          logoutSignedInElsewhere(history);
        }
        return responseData;
      })
      .catch(e => {
        console.error("[App] check_meta_date failed", e);
      });

  }

  const authPaths = ['/', '/login', '/forgotpassword', '/forgotusername', '/register', '/successforgot', '/username'];
  const isAuthPath = authPaths.some((path) => location.pathname === path)
    || location.pathname.startsWith('/set-new-password');

  if (maintenanceChecked && maintenanceMode && !isSuperAdminSession && !isAuthPath) {
    return <Maintenance message={maintenanceMessage} />;
  }

  return (
    <>
    <ImpersonationBanner />
    <ForceLogoutPoller onMaintenance={handleSessionMaintenance} />
    <AppPropsContext.Provider value={props}>
    <Switch>
    <Route path="/" component={Login} redirect exact/>
    <Route path="/login" component={Login} redirect exact/>
    <Route path="/register" component={Registration} exact/>
    <Route path="/logout" component={Logout} exact/>
    <Route path="/forgotpassword" component={Forgotpassworduser} exact/>
    <Route path="/successforgot" component={Successpassword} exact/>
    <Route path="/set-new-password/:id" component={Setnewpassworduser} exact />
    <Route path="/forgotusername" component={ForgotUserName} exact />
    <Route path="/username" component={SuccessUsername} exact />
   
    
  
   {/* configurational Modules */}
   <PrivateRoute path="/config-report"  component={NonfuelConfigReport} exact />
   <PrivateRoute path="/config-report/:id"  component={NonfuelConfigReport} exact />
   <PrivateRoute path="/settings"  component={Settings } exact />
   <PrivateRoute path="/subscription"  component={Subscription} exact />
   <PrivateRoute path="/subscription/:id"  component={Subscription  } exact />
   <PrivateRoute path="/pump-details"  component={PumpDetails} exact />
   {/* <PrivateRoute path="/fuel-config"  component={createAppRoute(FuelConfig)} exact /> */}
   <PrivateRoute path="/fuel-config"  component={FuelConfig2 } exact />
   <PrivateRoute path="/nozzle-config"  component={NozzleConfig } exact />
   <PrivateRoute path="/tank-config"  component={TankConfig } exact  />
   <PrivateRoute path="/target-config"  component={TargetConfig } exact  />
   {/* <PrivateRoute path="/rack-config"  component={createAppRoute(RackConfig)} exact  /> */}
   <PrivateRoute path="/rack-config"  component={RackConfig1 } exact  />
   <PrivateRoute path="/rack-config/:id"  component={RackConfig1 } exact  />
   <PrivateRoute path="/products"  component={Product} exact  />
   <PrivateRoute path="/products/:id"  component={Product} exact  />
   <PrivateRoute path="/Productsconfig"  component={Productsconfig} exact  />
   <PrivateRoute path="/Productsconfig/:id"  component={Productsconfig} exact  />
   <PrivateRoute path="/gas_cylinder_sales"  component={GasCylinderSalesConfig} exact/>
   <PrivateRoute path="/gas_cylinder_sales_empoyee"  component={GasCylinderSalesEmployeeConfig} exact/>
   <PrivateRoute path="/gas_cylinder_purchase"  component={GasCylinderPurchaseConfig} exact/>
   <PrivateRoute path="/fuel-config-report"  component={fuelConfigReport} exact  />
   <PrivateRoute path="/fuel-config-report/:id"  component={fuelConfigReport} exact  />
   {/* <PrivateRoute path="/non-fuel-config-report"  component={createAppRoute(NonfuelConfigReport)} exact  /> */}
   <PrivateRoute path="/users/:id"  component={UsersList} exact  />
   <PrivateRoute path="/users"  component={UsersList} exact  />
   <PrivateRoute path="/product-rack"  component={ProductRack } exact  />
   <PrivateRoute path="/rack-product-list"  component={RackProductList } exact  />
   <PrivateRoute path="/creditor-debitor"  component={CreditDebit} exact  />
   <PrivateRoute path="/creditor-debitor/:id"  component={CreditDebit } exact  />
   <PrivateRoute path="/digital-payment"  component={DigitalPayment } exact  />
   <PrivateRoute path="/digital-payment/:id"  component={DigitalPayment} exact  />
   <PrivateRoute path="/customers/:id"  component={Customer } exact  />
   <PrivateRoute path="/customers"  component={ Customer }  exact  />
   <PrivateRoute path="/bank-opening"  component={BankOpeningBalance } exact  />
   <PrivateRoute path="/bank-opening/:id"  component={BankOpeningBalance } exact  />
   <PrivateRoute path="/fleet-card-config"  component={FleetCardConfig } exact  />
   <PrivateRoute path="/fleet-card-config/:id"  component={FleetCardConfig} exact  />

   <PrivateRoute path="/loose-oil-config"  component={LooseOilComponent } exact  />
   <PrivateRoute path="/loose-oil-config/:id"  component={LooseOilComponent } exact  />
   <PrivateRoute path="/loose-oil-machine"  component={Loosebarrelmachine } exact  />

   <PrivateRoute path="/MLA-coupon"  component={MlaCoupon } exact  />
   <PrivateRoute path="/MLA-coupon/:id"  component={MlaCoupon } exact  />
   {/* <PrivateRoute path="/employee"  component={createAppRoute(EmployeeOpeningBalance)} exact  /> */}
   <PrivateRoute path="/vendor-config/:id"  component={VendorConfig } exact  />
   <PrivateRoute path="/vendor-config"  component={VendorConfig } exact  />
   <PrivateRoute path="/dealership-config"  component={createAppRoute(DealershipConfig)} exact  />
   <PrivateRoute path="/open-balance"  component={createAppRoute(OpenBalance)} exact  />
   <PrivateRoute path="/owntanker-config"  component={OwnTankerConfig } exact  />
   <PrivateRoute path="/owntanker-config/:id"  component={OwnTankerConfig } exact  />
   <PrivateRoute path="/tanker-income"  component={TankerConfig } exact  />
   <PrivateRoute path="/tanker-income/:id"  component={TankerConfig } exact  />
   <PrivateRoute path="/tanker-expense"  component={TankerExpConfig } exact  />
   <PrivateRoute path="/tanker-expense/:id"  component={TankerExpConfig } exact  />
   {/* <PrivateRoute path="/tanker"  component={createAppRoute(TankerConfig)} exact  /> */}
    <PrivateRoute path="/assets"  component={MachineriesConfig  } exact  />
   <PrivateRoute path="/assets/:id"  component={MachineriesConfig } exact  /> 
   <PrivateRoute path="/other-income"  component={OtherIncome } exact  />
   <PrivateRoute path="/other-income/:id"  component={OtherIncome } exact  />
   <PrivateRoute path="/expenses"  component={ExpensesConfig } exact  />
   <PrivateRoute path="/expenses/:id"  component={ExpensesConfig } exact  />
   <PrivateRoute path="/task-config"  component={TaskConfig} exact  />
   <PrivateRoute path="/task-config/:id"  component={TaskConfig} exact  />
   <PrivateRoute path="/fuel-unloading"  component={createAppRoute(FuelUnloading)} exact  />
   <PrivateRoute path="/cbalance-sheet"  component={BalanceSheet} exact/>
   <PrivateRoute path="/cbalance-sheet/:id"  component={BalanceSheet} exact/>
   <PrivateRoute path="/balance-sheet"  component={createAppRoute(BalanceSheet1)} exact  />
   <PrivateRoute path="/permission"  component={createAppRoute(Permision)} exact  />
   <PrivateRoute path="/role-list"  component={createAppRoute(Roles)} exact  />

   {/* operational modules */}
   <PrivateRoute path="/operational-settings" component={createAppRoute(OperationalSettings)} exact />
   <PrivateRoute path="/login-header-operational" component={createAppRoute(LoginHeaderOperational)} exact />
   <PrivateRoute path='/operational-date' component={createAppRoute(OperationalDate)}/>
   <PrivateRoute path='/operational-dates' component={createAppRoute(OperationalDates)}/>
   <PrivateRoute path="/nozzle-employee-list" component={createAppRoute(NozzleAlloEmplist)} exact />
   <PrivateRoute path="/nozzle-closing" component={createAppRoute(NozzleAllocation)} exact />
   {/* <PrivateRoute path="/nozzle-employee-list" component={createAppRoute(NozzleAlloEmplist2)} exact /> */}
   <PrivateRoute path="/newnozzle-closing" component={createAppRoute(NozzleAllocation2)} exact />
   {/* <PrivateRoute path="/packed-oil-list" component={createAppRoute(PackedOilConfig)} exact /> */}
   {/* <PrivateRoute path="/loose-oil-list" component={createAppRoute(LooseOilConfig)} exact /> */}
   <PrivateRoute path="/credit-sales" component={createAppRoute(CreditSalesConfig)} exact />
   <PrivateRoute path="/mla-coupon-sales" component={createAppRoute(MlaCouponConfig)} exact />
   <PrivateRoute path="/fleet-card-sales" component={createAppRoute(FleetCardSalesConfig)} exact />
   <PrivateRoute path="/card-sales" component={createAppRoute(CardSalesConfig)} exact />
   <PrivateRoute path="/bag-collection" component={createAppRoute(BagCollectionConfig)} exact />
   <PrivateRoute path="/ReceiptVoucher" component={createAppRoute(ReceiptVoucherConfig)} exact />
   <PrivateRoute path="/expense" component={createAppRoute(ExpenseConfig)} exact />
   <PrivateRoute path="/cashpayment" component={createAppRoute(CashPaymentConfig)} exact />
   <PrivateRoute path="/closepayment" component={createAppRoute(ClosePaymentConfig)} exact />
   <PrivateRoute path="/recoup" component={createAppRoute(RecoupConfig)} exact />

   {/* Manger module */}
   <PrivateRoute path="/receipt" component={createAppRoute(ReceiptConfig)} exact />
   <PrivateRoute path="/payment" component={createAppRoute(PaymentVoucherConfig)} exact />
   <PrivateRoute path="/nonfuel-product-direct" component={createAppRoute(NonFuelProductConfig)} exact />
   <PrivateRoute path="/nonfuel-product-direct-employee" component={createAppRoute(NonFuelProductConfigEmployee)} exact />

   <PrivateRoute path="/oil-barrel-sales" component={createAppRoute(OilBarrelProductConfig)} exact />
   <PrivateRoute path="/oil-barrel-sales-employee" component={createAppRoute(OilBarrelProductConfigEmployee)} exact />
   <PrivateRoute path="/fuel-sell-price" component={createAppRoute(FuelSellPriceConfig)} exact />
   <PrivateRoute path="/nonfuel-product-purchase" component={createAppRoute(NonFuelProductPurchaseConfig)} exact />
   <PrivateRoute path="/product-transfer-rack" component={createAppRoute(ProductTransferRackConfig)} exact /> 
   <PrivateRoute path="/account-to-account-transfer" component={createAppRoute(AccountToAccountConfig)} exact /> 
   <PrivateRoute path="/day-closing-operation" component={createAppRoute(DayClosingOperationConfig)} exact /> 
   <PrivateRoute path="/day-closing-screen" component={createAppRoute(DayClosingScreenConfig)} exact /> 
   <PrivateRoute path="/purchase-return-non-fuel" component={createAppRoute(PurchaseReturnNonFuelConfig)} exact /> 
   <PrivateRoute path="/subscription-management" component={createAppRoute(SubscriptionManagementConfig)} exact /> 
   <PrivateRoute path="/invoice-settings" component={createAppRoute(InvoiceSettingsConfig)} exact /> 
   <PrivateRoute path="/user-management-op" component={createAppRoute(UserManagementConfig)} exact /> 
   <PrivateRoute path="/user-management-op/:id" component={createAppRoute(UserManagementConfig)} exact />
   <PrivateRoute path="/notification-setting" component={createAppRoute(NotificationSettingConfig)} exact /> 
   <PrivateRoute path="/NonFuel-product-Selling-Price-Change" component={createAppRoute(NonFuelProductSellingPriceChangeConfig)} exact /> 
    {/* Density and DSR */}
   <PrivateRoute path="/density" component={createAppRoute(DensityConfig)} exact /> 
   <PrivateRoute path="/op-density-report" component={createAppRoute(Density)} exact /> 
   <PrivateRoute path="/dsr" component={createAppRoute(DsrConfig)}  exact /> 
  {/* {fuel_unloding} */}
  {/* <PrivateRoute path="/op-fuel-unloading" component={createAppRoute(FuelUnloadingConfig1)}exact /> */}
  <PrivateRoute path="/op-fuelunloading" component={createAppRoute(FuelUnloadingConfig)}exact /> 
  <PrivateRoute path="/fuel-unloading-2" component={createAppRoute(FuelUnloadingConfig2)} exact />
  <PrivateRoute path="/decanting-ms" component={createAppRoute(DecantingMSConfig)}  exact /> 
  <PrivateRoute path="/fuel-unloading-density" component={createAppRoute(FuelUnloadingDensityConfig)}  exact />  
  <PrivateRoute path="/density-after-unloading" component={createAppRoute(DensityAfterUnloadConfig)}  exact /> 
  <PrivateRoute path="/fuel-unload" component={createAppRoute(FuelUnConfig)}  exact /> 
  <PrivateRoute path="/day-closing" component={DayClosingConfig }  exact /> 

  {/* Blance Sheet _operational-model  ---(Athulya A(07/06/2021:2pm)*/}
  <PrivateRoute path="/op-balance-sheet"  component={createAppRoute(BalanceSheetOP)} exact /> 
  <PrivateRoute path="/op_profit_loss"  component={createAppRoute(ProfitLossOP)} exact /> 
  <PrivateRoute path="/op-simplified-balance-sheet"  component={createAppRoute(SimplifiedBalanceSheet)}exact /> 
  <PrivateRoute path="/op-financial-statements"  component={createAppRoute(FinancialStatements)} exact />
  <PrivateRoute path="/statutory-filing-reports" component={createAppRoute(StatutoryFilingReports)} exact /> 
  <PrivateRoute path="/owner-dashboard" component={createAppRoute(OwnerDashboard)} exact />
  <PrivateRoute path="/owner-analytics" component={createAppRoute(OwnerAnalyticsReport)} exact />
  <PrivateRoute path="/daily-transaction-sheet"  component={createAppRoute(DailyTransactionSheet)} exact />
  <PrivateRoute path="/trade-profit-loss" component={createAppRoute(TradeProfitLossReport)} exact />
  <PrivateRoute path="/short-excess-report" component={createAppRoute(ShortExcessReport)} exact />
  <PrivateRoute path="/other-income-report" component={createAppRoute(OtherIncomeReport)} exact />
  <PrivateRoute path="/customer-statement" component={createAppRoute(CustomerStatementReport)} exact />
  <PrivateRoute path="/bank-statement" component={createAppRoute(BankStatementReport)} exact />
  <PrivateRoute path="/dealer-statement" component={createAppRoute(DealerStatementReport)} exact />
  <PrivateRoute path="/fleetcard-statement" component={createAppRoute(FleetCardStatementReport)} exact />
  <PrivateRoute path="/mla-coupon-statement" component={createAppRoute(MlaCouponStatementReport)} exact />
  <PrivateRoute path="/nonfuel-purchase-report" component={createAppRoute(NonFuelPurchaseReport)} exact />
  <PrivateRoute path="/nonfuel-sales-report" component={createAppRoute(NonFuelSalesReport)} exact />
  <PrivateRoute path="/nonfuel-stock-statement" component={createAppRoute(NonFuelStockStatementReport)} exact />
  <PrivateRoute path="/recoup-statement" component={createAppRoute(RecoupStatementReport)} exact />
  <PrivateRoute path="/nozzle-report" component={createAppRoute(NozzleReport)} exact />
  <PrivateRoute path="/looseoil-barrel-sales-report" component={createAppRoute(LooseOilBarrelSalesReport)} exact />
  <PrivateRoute path="/daily-transaction-summary" component={createAppRoute(DailyTransactionSummary)} exact />
  <PrivateRoute path='/op-worksheet' component={createAppRoute(EmployeeWorkSheet)} exact/>
  <PrivateRoute path='/op-dsr-report' component={createAppRoute(DsrReportComponent)} exact/>
  <PrivateRoute path="/statement-of-account/:headId?" component={createAppRoute(AccountStatementReport)} exact />
  <PrivateRoute path="/stock-gain-loss" component={createAppRoute(StockGainLossReport)} exact />
  <PrivateRoute path="/other-reports/:slug" component={createAppRoute(OtherReportRouter)} exact />
  <PrivateRoute path='/dashboard' component={createAppRoute(DashBoard)}  exact />

   <PrivateRoute path='/op-fuel-edit' component={createAppRoute(FuelEdit)}/>
  <PrivateRoute path='/op-tank-edit' component={createAppRoute(TankEdit)}/>
  <PrivateRoute path='/tank-view' component={TankModalView}/>
  <PrivateRoute path='/op-nozzle-edit' component={createAppRoute(NozzleEdit)}/> 
  
  {/*Notification*/ }
  <PrivateRoute path='/all_notifications/:id' component={createAppRoute(AllNotification)}/>
  <PrivateRoute path='/report-downloads' component={createAppRoute(ReportDownloads)} exact />
  

  {/* payment response */}

  <PrivateRoute path="/payment-Failed" component={createAppRoute(paymentFailed)} /> 
  <PrivateRoute path="/payment-Success" component={createAppRoute(PaymentSuccess)} /> 


{  /**********super admin**********/}


<PrivateRoute path="/admin_dashboard" component={createAppRoute(AdminDashBoard)} exact /> 
<PrivateRoute path="/admin-ledger-errors/:pumpId" component={createAppRoute(AdminLedgerErrors)} exact />
<PrivateRoute path="/admin-ledger-errors" component={createAppRoute(AdminLedgerErrors)} exact />
<PrivateRoute path="/admin-tank-stock-errors/:pumpId" component={createAppRoute(AdminTankStockErrors)} exact />
<PrivateRoute path="/admin-tank-stock-errors" component={createAppRoute(AdminTankStockErrors)} exact />
<PrivateRoute path="/admin-pump/:pumpId" component={createAppRoute(AdminPumpDetail)} exact />
<PrivateRoute path="/admin-alerts" component={createAppRoute(AdminAlertsCenter)} exact />
<PrivateRoute path="/admin-support" component={createAppRoute(AdminSupportCenter)} exact />
<PrivateRoute path="/admin-support-tickets" component={createAppRoute(AdminSupportCenter)} exact />
<PrivateRoute path="/admin-master-settings" component={createAppRoute(AdminMasterSettings)} exact />
<PrivateRoute path="/admin-system-monitoring" component={createAppRoute(AdminSystemMonitoring)} exact />
<PrivateRoute path="/admin-analytics" component={createAppRoute(AdminPlatformAnalytics)} exact />
<PrivateRoute path="/admin-business-insights" component={createAppRoute(AdminBusinessInsights)} exact />
<PrivateRoute path="/admin-audit-log" component={createAppRoute(AdminAuditLog)} exact />
<PrivateRoute path="/pump_name" component={createAppRoute(SetPump)} exact />
   <PrivateRoute path="/admin-role-list" component={createAppRoute(AdminRoles)} exact />
<PrivateRoute path="/admin-subscription-management" component={createAppRoute(AdminSubscriptionManagement)} exact />
<PrivateRoute path="/admin-payment-management" component={createAppRoute(AdminPaymentManagement)} exact />
<PrivateRoute path="/admin-invoice-settings" component={createAppRoute(AdminInvoiceSettings)} exact />
   <PrivateRoute path="/admin-user-management" component={createAppRoute(AdminUserManagementConfig)} exact /> 
   <PrivateRoute path="/admin-pumps-details" component={createAppRoute(AdminPumpsDetailscomponent)} exact />
<Route component={PageNotFound} />

  
</Switch>
    </AppPropsContext.Provider>
    </>
  );
}
